export default __webpack_public_path__ + "static/media/PPI-garden-bed-006.bf75b5b8.jpg";